import { useRef } from 'react';
import { Col } from 'react-bootstrap';

import FilterServiceRequest from '../ServiceRequest/FilterServiceRequest/FilterServiceRequest';
import { useDrawerContext } from '../../context/DrawerContext';
import { useFilterPinned } from '../../hooks/usePinnedFilter';

import ApproverWorkReport from './ApproverWorkReport';
import '../ServiceRequest/ServiceRequest.scss';

const ApproverViewLayout = () => {
  const { activeDrawer, setActiveDrawer, closeDrawer } = useDrawerContext();

  const { isFilterPinned, setIsFilterPinned } = useFilterPinned();

  const fixedDrawerHeightRef = useRef(null);

  const contentCardClass = !isFilterPinned ? 'container-filter-resultGrilla' : 'inbox-height-calc';
  const onAnchor = () => {
    setIsFilterPinned(!isFilterPinned);
  };

  return (
    <div className="pas-container overflow-x-hidden">
      <div className={contentCardClass}>
        <FilterServiceRequest
          hideModal={closeDrawer}
          isFilterPinned={isFilterPinned}
          onAnchor={onAnchor}
          ref={fixedDrawerHeightRef}
          show={activeDrawer}
          showAnchor
        />

        <Col className="container-title-table scrolled-table" ref={fixedDrawerHeightRef} sm={9}>
          <ApproverWorkReport setShowFilters={setActiveDrawer} />
        </Col>
      </div>
    </div>
  );
};

export default ApproverViewLayout;
